import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { usePlaylists } from "../../api/playlists-api";
import { useHistory } from "react-router-dom";

export const PlaylistsList = () => {
  const history = useHistory();
  const columns = [
    {
      field: "imageUrl",
      headerName: "",
      renderCell: (params: any) => {
        return (
          <img
            key={params.value}
            src={`${params.value}?height=36`}
            height="36px"
            width="36px"
            alt=""
          />
        );
      },
    },
    {
      field: "name",
      headerName: "Name",
      renderCell: (params: any) => {
        return (
          <div
            onClick={() => {
              history.push(`/playlists/${params.id}`);
            }}
            style={{
              textDecoration: "underline",
              color: "blue",
              cursor: "pointer",
            }}
          >
            {params.value}
          </div>
        );
      },
      flex: 1,
    },
    {
      field: "isPublic",
      headerName: "Public",
      renderCell: (params: any) => {
        return <div>{params.value?.toString() === "true" ? "YES" : "NO"}</div>;
      },
      flex: 1,
    },
    {
      field: "isProgram",
      headerName: "Program",
      renderCell: (params: any) => {
        return <div>{params.value?.toString() === "true" ? "YES" : "NO"}</div>;
      },
      flex: 1,
    },
  ];
  const { data } = usePlaylists();
  return (
    <div style={{ height: 600, width: "100%" }}>
      {data ? (
        <DataGrid rows={data} columns={columns} disableSelectionOnClick />
      ) : (
        <div>loading...</div>
      )}
    </div>
  );
};
